import React from 'react';
interface RoofEmblemProps {
  className?: string;
}
export function RoofEmblem({
  className = 'w-12 h-12'
}: RoofEmblemProps) {
  return <svg viewBox="0 0 200 120" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${className} shrink-0`} aria-hidden="true" data-id="element-246">
      {/* Red Roof Triangle */}
      <path d="M100 20 L160 80 L120 80 L100 60 L80 80 L40 80 Z" fill="#BF0A30" data-id="element-247" />
      {/* Navy Block */}
      <rect x="85" y="20" width="30" height="60" fill="#002868" data-id="element-248" />
      {/* White Star */}
      <path d="M100 45 L103 52 L110 52 L105 57 L107 64 L100 60 L93 64 L95 57 L90 52 L97 52 Z" fill="#FFFFFF" data-id="element-249" />
      {/* Red Bottom Bar */}
      <path d="M20 95 L180 95 L170 105 L20 105 Z" fill="#BF0A30" data-id="element-250" />
    </svg>;
}